import React from "react";
import { Box, Button, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DevEmailSendWarning } from "./DevEmailSendWarning";
import "./EventConfirmModal.css";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 480,
  maxWidth: "calc(100vw - 32px)",
  bgcolor: "background.paper",
  borderRadius: "12px",
  boxShadow: 24,
  p: "28px 34px 34px",
  outline: "none",
  textAlign: "center",
};

export const CancelEventConfirmModal = ({
  open,
  onClose,
  onConfirm,
  confirming = false,
  recipients = [],
}) => {
  const hasRecipients = (recipients || []).filter(Boolean).length > 0;
  return (
    <Modal
      open={open}
      onClose={confirming ? undefined : onClose}
      aria-labelledby="cancel-event-confirm-title"
    >
      <Box sx={modalStyle} className="event-confirm-modal">
        <button
          type="button"
          className="event-confirm-modal__close"
          onClick={onClose}
          disabled={confirming}
          aria-label="Close"
        >
          <CloseIcon sx={{ fontSize: 18 }} />
        </button>

        <h2 id="cancel-event-confirm-title">Cancel Event?</h2>
        <p className="event-confirm-modal__body">
          {hasRecipients
            ? "Are you sure you want to cancel this event? This will notify all registered attendees that the event is cancelled"
            : "Are you sure you want to cancel this event? There are no employees on the roster, so no cancellation emails will be sent."}
        </p>
        <DevEmailSendWarning recipients={recipients} />

        <div className="event-confirm-modal__actions">
          <Button
            type="button"
            variant="outlined"
            className="event-confirm-modal__btn-secondary"
            onClick={onClose}
            disabled={confirming}
          >
            Keep Event
          </Button>
          <Button
            type="button"
            variant="contained"
            className="event-confirm-modal__btn-primary"
            disableElevation
            onClick={onConfirm}
            disabled={confirming}
          >
            {confirming ? "Cancelling…" : "Cancel Event"}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};
